module.exports = __webpack_public_path__ + "img/卓尔荟(上海卓瑞门诊).58d7ed0.png";